<template>
  <div class="text-center">
    <b-spinner
      style="width: 7rem; height: 7rem; color: #5445f3"
      class="mt-5"
      label="Large Spinner"
    ></b-spinner>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import NotificationSample from "../Components/NotificationSample";
import api from "../../../axios_api";
export default {
  components: {},
  data() {
    return {};
  },
  computed: {},
  mounted() {
    if (localStorage.getItem("updateProfile")) {
      localStorage.removeItem("updateProfile");
      let account_id = this.$store.getters["user/id"];
      this.$router.push(
        `/${account_id}/profile?user=${this.$route.query.user}&type=${this.$route.query.type}`
      );
    } else if (this.$route.query.user && this.$route.query.type) {
      if (localStorage.getItem("invitedBy")) {
        let user = window.atob(this.$route.query.user);
        user = JSON.parse(user);
        let invited = JSON.parse(localStorage.getItem("invitedBy"));
        if (user.email == window.atob(invited.email)) {
          this.createUser(true, window.atob(invited.role));
        } else {
          alert("Invited Email does not match");
          this.$router.push("#/login");
        }
      } else {
        this.createUser(false, 0);
      }
    } else this.$router.push("#/login");
  },
  methods: {
    userProfileNavigation() {
      let self = this;
      if (window.localStorage.getItem("fiifi")) {
        let fiifi = window.localStorage.getItem("fiifi");
        fiifi = JSON.parse(fiifi);
        let emailUserId = window.localStorage.getItem("userUnscribe");
        window.localStorage.removeItem("userUnscribe");
        if (
          fiifi.user.id &&
          fiifi.user.id.length > 0 &&
          emailUserId == fiifi.user.id
        ) {
          this.$router.push(`/${fiifi.user.id}/profile`);
          window.localStorage.removeItem("userUnscribe");
        } else {
          this.$router.push(`/${fiifi.user.id}/workspace`);
        }
      }
    },
    createUser(invite, role) {
      let user = JSON.parse(window.atob(this.$route.query.user));
      let image = user.image;
      let createdUser = {
        firstName: user.firstName,
        lastName: user.lastName,
        email: user.email,
        account_id: 0,
      };
      createdUser[this.$route.query.type] = user;
      createdUser.type = this.$route.query.type;
      api
        .post("/user", { encrypt: { data: createdUser } })
        .then((res) => {
          let jDetails = res.data.encrypt.success;
          let user = res.data.encrypt.success.user;
          user.id = res.data.encrypt.success.user._id;
          user.token = jDetails.token;
          user.isNew = jDetails.isNew;
          user.image = image;
          user.id = res.data.encrypt.success.user._id;
          this.$store.commit("user/token", { token: jDetails.token });
          this.$store.commit("portfolio/markData", {
            hasData: jDetails.hasData,
          });
          let account_id = res.data.encrypt.success.user._id;
          user.email = createdUser.email ? createdUser.email : "";
          this.$store.commit("user/user", {
            user,
          });
          if (image && image.length > 0)
            this.setImage(this.$route.query.type, image);
          if (createdUser.email)
            window.localStorage.setItem("email", createdUser.email);
          this.addAccount(user, this.$route.query.type);
          if (invite == true) this.invitedUser();
          else {
            this.$store.commit("portfolio/setAccountId", account_id);
            this.$store.dispatch("notifications/start", null, { root: true });
            this.$store
              .dispatch("accountPlans/getAccountPlanFeatures")
              .then((plans) => {
                this.$store
                  .dispatch("workspace/apiFetchworkspaces")
                  .then((data) => {
                    if (window.localStorage.getItem("userUnscribe")) {
                      this.userProfileNavigation();
                    } else {
                      if (
                        window.localStorage.getItem("todoEmailPreferencesCheck")
                      ) {
                        this.loginTodoRedirect(account_id);
                      } else {
                        if (
                          !window.localStorage.getItem(
                            "share-portfolio-permalink"
                          ) &&
                          !window.localStorage.getItem("plan")
                        ) {
                          this.$router.push(`/${account_id}/workspace`);
                        } else {
                          if (
                            window.localStorage.getItem(
                              "share-portfolio-permalink"
                            )
                          ) {
                            if (
                              window.localStorage.getItem(
                                "share-portfolio-referred"
                              )
                            ) {
                              this.$router.push(
                                `${account_id}/shared/company?permalink=${window.localStorage.getItem(
                                  "share-portfolio-permalink"
                                )}&back=workspace&a=${window.localStorage.getItem(
                                  "share-portfolio-referred"
                                )}`
                              );
                            } else {
                              this.$router.push(
                                `${account_id}/shared/company?permalink=${window.localStorage.getItem(
                                  "share-portfolio-permalink"
                                )}&back=workspace`
                              );
                            }
                          }
                          if (window.localStorage.getItem("plan")) {
                            this.$router.push(
                              `${account_id}/payments?plan=${window.localStorage.getItem(
                                "plan"
                              )}`
                            );
                          }
                        }
                      }
                    }
                  });
              });
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    loginTodoRedirect(accountId) {
      let todoEmailPreferencesCheck = JSON.parse(
        window.localStorage.getItem("todoEmailPreferencesCheck")
      );
      let self = this;
      if (accountId == todoEmailPreferencesCheck.a) {
        let workspaces = this.$store.getters["workspace/workspaces"];
        let currentWorkspace = workspaces.find((item) => {
          if (
            item.workspace &&
            item.workspace._id == todoEmailPreferencesCheck.w
          )
            return item;
        });
        if (currentWorkspace && currentWorkspace._id) {
          var defaultPayload = {
            workspace_title: currentWorkspace.workspace.title,
            workspace_type: currentWorkspace.workspace.type,
            workspace_id: currentWorkspace.workspace._id,
            sectors: currentWorkspace.workspace.sectors,
            stages: currentWorkspace.workspace.stages,
          };
          this.$store.commit("workspace/setDefaultPipeline", {
            payload: defaultPayload,
          });
          this.$store.commit("user/workspace_id", {
            workspace_id: currentWorkspace.workspace._id,
          });
          self.$store.dispatch("dashboardCoordinates/apiFetchCoordinates");
          self.$store
            .dispatch("workspacePlans/getWorkspacePlanFeatures", {
              workspace_id: currentWorkspace.workspace._id,
            })
            .then((workspacePlans) => {
              self.$store.dispatch("arbiter/start");
              window.localStorage.removeItem("todoEmailPreferencesCheck");
              self.$router.push(
                `${accountId}/${currentWorkspace.workspace._id}/todos?id=${todoEmailPreferencesCheck.t}`
              );
            });
        } else {
          window.localStorage.removeItem("todoEmailPreferencesCheck");
          this.$router.push(`/${account_id}/workspace`);
        }
      } else {
        window.localStorage.removeItem("todoEmailPreferencesCheck");
        this.$router.push(`/${account_id}/workspace`);
      }
    },
    addAccount(user, type) {
      let image;
      if (type == "linkedin")
        image =
          user.image && user.image.length > 1
            ? user.image[3].value || user.image[0].value || ""
            : "";
      else image = user.image || "";
      let userObj = {
        _id: user._id || user.id,
        workspace_id: user.workspace_id,
        image: image,
        firstName: user.firstName,
        lastName: user.lastName,
        email: user.email,
      };
      if (window.localStorage.getItem("fiifiUsers")) {
        let users = JSON.parse(window.localStorage.getItem("fiifiUsers"));
        if (
          users.findIndex(
            (item) => item._id == userObj._id || item.email == userObj.email
          ) == -1
        ) {
          window.localStorage.removeItem("fiifiUsers");
          users.push(userObj);
          window.localStorage.setItem("fiifiUsers", JSON.stringify(users));
        }
      } else {
        let users = [];
        users.push(userObj);
        window.localStorage.setItem("fiifiUsers", JSON.stringify(users));
      }
    },
    setImage(type, images) {
      if (type == "linkedin")
        this.$store.commit("user/image", {
          image: images[3].value || images[0].value || "",
        });
      else
        this.$store.commit("user/image", {
          image: images || "",
        });
    },
    invitedUser() {
      let invited = JSON.parse(localStorage.getItem("invitedBy"));
      let payload = {
        account_id: window.atob(invited.by),
      };
      api
        .patch("/invited/user", { encrypt: { data: payload } })
        .then((resp) => {
          let user = resp.data.encrypt.success;
          this.$store.commit("user/account_id", {
            account_id: user.account_id,
          });
          setTimeout(() => {
            localStorage.removeItem("invitedBy");
            this.$router.push("/");
          }, 3500);
        })
        .catch((err) => console.log("FAILURE", err));
    },
    updateRole(account, profile, role) {
      //add role to the user
      let acc_role = {
        account,
        profile,
        role,
      };
      api
        .post("/account", { encrypt: { data: acc_role } })
        .then((resp) => {
          this.setRole(resp.data.encrypt.success);
        })
        .catch((err) => {
          console.log(err);
        });
    },
    setRole(role) {
      //set role object to store
      var arr = [];
      role.map((item) => {
        var roleObj = {
          _id: item._id,
          account: item.account,
          profile: item.profile,
          permission: item.role.permission,
          name: item.role.name,
        };
        arr.push(roleObj);
      });
      this.$store.commit("role/setAccRole", { account_role: arr });
      this.$store.commit("role/setCurrentRole", { current_role: arr[0] });
    },
    checkRole(user, checkInvite) {
      //TO check whether which role has to addedd..!!
      if (checkInvite == true)
        this.updateRole(
          window.atob(JSON.parse(localStorage.invitedBy).by),
          user.uuid,
          window.atob(JSON.parse(localStorage.invitedBy).role)
        );
      else this.updateRole(user.uuid, user.uuid, "5e35bd642222cc03ac0506bd");
    },
  },
};
</script>
<style>
</style>